<template>
    <div>
        <div class="row">
            <div
                v-for="(vehiculo, index) in inventario"
                :key="index"
                class="col-md-4 grid_listing"
            >
                <div class="product-listing-m">
                    <div class="product-listing-img">
                        <a :href="`/ficha_tecnica/${vehiculo._id}?type=offers`">
                            <img
                                :src="
                                    rotate_image(vehiculo.fotos[0])
                                "
                                class="img-fluid"
                                alt="image"
                            />
                        </a>
                        <div class="label_icon">
                            $ {{ vehiculo.precio | formatNumber }}
                        </div>
                        <div
                            v-if="vehiculo.peritaje"
                            class="i-shield"
                            data-toggle="tooltip"
                            data-html="true"
                            title="<em>Vehículo</em> <b>PERITADO</b>"
                        >
                            <i class="fa fa-shield" aria-hidden="true" id="icon-shield"></i>
                        </div>
                    </div>
                    <div class="product-listing-content">
                        <h5 class="a-title">
                            <a :href="`/ficha_tecnica/${vehiculo._id}?type=offers`">
                                {{ vehiculo.marca }}
                                {{ vehiculo.linea }}
                            </a>
                        </h5>
                        <p class="list-price">
                            {{ vehiculo.modelo }}
                            |
                            {{ get_tipo_caja(vehiculo.caja) }}
                            |
                            {{ vehiculo.clindraje | formatNumber }}
                            cc |
                            {{ vehiculo.kilometraje | formatNumber }}
                            km
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="pagination" style="width: 100%;">
                <b-pagination
                    pills
                    v-model="links.current_page"
                    :total-rows="links.total"
                    :per-page="links.per_page"
                    aria-controls="my-table"
                    @change="goPage"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
        ...mapFields("buscador", ["inventario", "links"])
    },
    data: () => ({
        vehiculos: []
    }),
    methods: {
        goPage(val) {
            // console.log(">>>>", window.location.href);
            window.location.href = "/ofertas?page=" + val;
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        },
        rotate_image(id_image) {
            return (
                "https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/" +
                id_image
            );
        }
    }
};
</script>

<style lang="scss">
.grid_listing .product-listing-content h5 {
    line-height: 26px;
    margin: 0 auto 20px;
    font-size: 16px;
    margin-bottom: 0px;
}
.label_icon {
    background: #000000d6;
    font-weight: 700;
    font-size: 16px;
}

/* .img-fluid {
    max-width: 100%;
    min-height: 190px;
} */

p.list-price {
    font-size: 14px !important;
}
h5.a-title {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.grid_listing .product-listing-content {
    padding: 10px 10px 0;
}

ul.features_list {
    margin-top: 0px !important;
}

ul.features_list > li {
    text-align: center;
}

.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #d3d3d3;
    border-color: #d3d3d3;
}

.page-link {
    color: #161a1d;
}
</style>
